import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  BehaviorSubject,
  Observable,
  catchError,
  map,
  of,
  throwError,
} from 'rxjs';
import { Code } from 'src/app/core/shared/models/code';
import { ControlBase } from 'src/app/core/shared/models/control-base';
import { Dropdown } from 'src/app/core/shared/models/dropdown';
import { TextBox } from 'src/app/core/shared/models/textbox';
import {
  ActivityContractor,
  Age,
  GeneralParameter,
} from '../models/general-parameters-response.model';
import { environment } from 'src/environments/environment';
import { DropdownObject } from 'src/app/core/shared/models/dropdown-object';
import { StepsInformation } from '../models/stepsInformation.model';
import { Parameter } from '../models/parameters.model';
import { Questionarie } from '../models/validation-strategy-response.model';
import { Client } from '../models/client.model';
import { DropdownClient } from 'src/app/core/shared/models/dropdown-clients';
import { Currency } from 'src/app/core/shared/models/currency';
import { NumberInput } from 'src/app/core/shared/models/number';
import { CreditApprobe } from 'src/app/core/shared/models/credit-approbe.model';
import { DocumentsRequest } from '../models/documents-request.model';
import { Document, DocumentResponse } from '../models/documents.model';
import { SignDocument } from '../models/sign-document.model';
import { Payment } from '../models/payment.model';
import { DataInformation } from '../models/data-information.model';
import { DropdownFees } from 'src/app/core/shared/models/dropdown-fees.model';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackComponent } from 'src/app/core/components/snack/snack.component';
import { Router } from '@angular/router';

import { DataTemplate } from 'src/app/core/shared/models/dataTemplate.model';
import { AuthorizatioData } from '../models/authorization.model';

export interface SnackInterface {
  codigo: string;
  description: string;
}

const initInfo: StepsInformation = {
  firstStep: {
    celular: '',
    numeroDocumento: '',
    tipoDocumento: {
      id: 0,
      description: '',
    },
    tipoIdentificacionText: '',
  },
  secondStep: {
    anio: '',
    dia: '',
    mes: '',
    primerNombre: '',
    primerApellido: '',
    email: '',
    diaNacimiento: '',
    mesNacimiento: '',
    anioNacimiento: '',
    direccion: '',
    googleMaps: '',
  },
  thirdStep: {
    numeroCuotas: '1',
    referenciaPago: '',
    monto: '',
    client: {
      createPowwi: 0,
      id: '',
      maxAmmount: 0,
      maxCreditTerm: 0,
      minAmmount: 0,
      minCreditTerm: 0,
      partnerName: '',
      blockTrade: 0,
      blockMessage: '',
      blockMessageSmall: '',
      urlBackbuttom: '',
      brand: '',
      partner_name: '',
      partner_nit: '',
      partner_image_url: '',
      partner_phone: '',
      by_approbe: '',
    },
  },
};

const initQuestionarie: Questionarie = {
  cuestionario: '',
  preguntas: [],
  registroCuestionario: '',
  rtaCuestionario: [],
};

const initCredit: CreditApprobe = {
  amountFinance: 0,
  fees: 0,
  fGA: 0,
  platform: 0,
  rateApprobeAnnual: 0,
  rateApprobeMonth: 0,
  validationStrategy: '',
  paid: '',
  cuotaBenefits: 0,
  feesBenefits: 0,
  signature: 0,
  handlingFee: 0,
  insurance: 0,
};

const initPayment: Payment = {
  amountFinance: 0,
  fees: 0,
  fGA: 0,
  platform: 0,
  numCredit: '',
  minPaid: '',
  rateApprobeAnnual: 0,
  rateApprobeMonth: 0,
  datePaid: '',
  validationStrategy: '',
  cuotaBenefits: 0,
  feesBenefits: 0,
  paid: '',
  signature: 0,
  handlingFee: 0,
  insurance: 0,
};

const initDataInformation: DataInformation = {
  id: '',
  tipoIdentificacion: '',
  identificacion: '',
  primerApellido: '',
  name: '',
  fullName: '',
  celularFormulario: '',
  emailFormulario: '',
  fechaExpedicion: '',
  client: '',
  ammount: 0,
  term: 0,
  validationStrategy: '',
  fechaSolicitud: '',
  referenciaPago: '',
  score: 0,
  feesApprobe: 0,
  rateApprobe: 0,
  approveValue: 0,
  scoreAcierta: 0,
  value: 0,
  valorCuota: 0,
  amountFinance: 0,
  status: '',
  fGA: 0,
  platform: 0,
  autorizacion: {
    data: '',
    name: '',
    pag: 0,
  },
  causalRechazo: '',
  pagare: {
    data: '',
    name: '',
    pag: 0,
  },
  urlRedirect: '',
  respuesta: '',
  typeIdentification: {
    description: '',
    id: '',
  },
};

const initDataTemplate: DataTemplate = {
  idClient: '',
  template: '',
};

@Injectable({
  providedIn: 'root',
})
export class BnplService {
  private _stepsInformation = new BehaviorSubject<StepsInformation>(initInfo);
  private _questionarieEmit = new BehaviorSubject<Questionarie>(
    initQuestionarie
  );
  private _creditEmit = new BehaviorSubject<CreditApprobe>(initCredit);
  private _payment = new BehaviorSubject<Payment>(initPayment);
  private _personalInformation = new BehaviorSubject<DataInformation>(
    initDataInformation
  );
  private _creditCupo = new BehaviorSubject<CreditApprobe>(initPayment);
  private _consumeCupo = new BehaviorSubject<CreditApprobe>(initPayment);

  private _dataTemplate = new BehaviorSubject<DataTemplate>(initDataTemplate);

  public get dataTemplate(): DataTemplate {
    return this._dataTemplate.getValue();
  }

  public set dataTemplate(v: DataTemplate) {
    this._dataTemplate.next(v);
  }

  public get creditCupo(): CreditApprobe {
    return this._creditCupo.getValue();
  }

  public set creditCupo(v: CreditApprobe) {
    this._creditCupo.next(v);
  }

  public get consumeCupo(): CreditApprobe {
    return this._consumeCupo.getValue();
  }

  public set consumeCupo(v: CreditApprobe) {
    this._consumeCupo.next(v);
  }

  public get stepsInformation(): StepsInformation {
    return this._stepsInformation.getValue();
  }

  public set stepsInformation(v: StepsInformation) {
    this._stepsInformation.next(v);
  }

  public get questionarieEmit(): Questionarie {
    return this._questionarieEmit.getValue();
  }

  public set questionarieEmit(v: Questionarie) {
    this._questionarieEmit.next(v);
  }

  public get creditEmit(): CreditApprobe {
    return this._creditEmit.getValue();
  }

  public set creditEmit(v: CreditApprobe) {
    this._creditEmit.next(v);
  }

  public get payment(): Payment {
    return this._payment.getValue();
  }

  public set payment(v: Payment) {
    this._payment.next(v);
  }

  public get personalInformation(): DataInformation {
    return this._personalInformation.getValue();
  }

  public set personalInformation(v: DataInformation) {
    this._personalInformation.next(v);
  }

  HttpUrl: any = environment.HttpUrl;
  age: Observable<Age>;
  clients: Observable<Client[]>;

  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {
    const data = {
      id: 0,
      httpMethod: 'GET',
    };
    this.age = this.selectinformation(data);
    this.clients = this.getClients().pipe(
      map((clients) =>
        clients.sort((a, b) => a.partnerName.localeCompare(b.partnerName))
      )
    );
  }

  emailPeticon(data: any): Observable<Parameter> {
    return this.http.post<Parameter>(
      `${this.HttpUrl}/IdVal`,
      data,
      this.httpOptions
    );
  }

  getDataAuthorization(data: any): Observable<AuthorizatioData> {
    return this.http.post<AuthorizatioData>(
      `${this.HttpUrl}/IdVal`,
      data,
      this.httpOptions
    );
  }

  getPartnerParameters(data: any): Observable<Parameter> {
    return this.http.post<Parameter>(
      `${this.HttpUrl}/partnerParameters`,
      data,
      this.httpOptions
    );
  }

  getClients(): Observable<Client[]> {
    return this.http.post<Client[]>(
      `${this.HttpUrl}/partnerParameters`,
      {},
      this.httpOptions
    );
  }

  getDataBoucher(data: any) {
    return this.http.post(`${this.HttpUrl}/IdVal`, data, this.httpOptions);
  }

  selectinformation(data: any): Observable<Age> {
    return this.http
      .post<GeneralParameter>(
        `${this.HttpUrl}/generalinformation`,
        data,
        this.httpOptions
      )
      .pipe(
        map((value) => value.age),
        catchError((error) => {
          this.router.navigate(['/await-alert', 'error-connection']);
          return throwError(() => new Error('Error', error));
        })
      );
  }

  signDocument(data: SignDocument): Observable<Payment> {
    return this.http.post<Payment>(
      `${this.HttpUrl}/IdVal`,
      data,
      this.httpOptions
    );
  }

  getDocuments(data: DocumentsRequest): Observable<Document[]> {
    return this.http
      .post<DocumentResponse>(`${this.HttpUrl}/IdVal`, data, this.httpOptions)
      .pipe(map((value) => value.documents));
  }

  getPersonalInformation(data: any) {
    return this.http.post(`${this.HttpUrl}/IdVal`, data, this.httpOptions);
  }

  getCreditCupo(data: any) {
    return this.http.post(`${this.HttpUrl}/IdVal`, data, this.httpOptions);
  }

  getConsumeCupo(data: any) {
    return this.http.post(`${this.HttpUrl}/IdVal`, data, this.httpOptions);
  }

  validateQuotasId(data: any) {
    return this.http.post(`${this.HttpUrl}/IdVal`, data, this.httpOptions);
  }

  /*wake up*/

  wakeUpIdVal() {
    return this.http.post(`${this.HttpUrl}/IdVal`, this.httpOptions);
  }
  wakeUpAuthentic() {
    return this.http.post(`${this.HttpUrl}/autentic`, this.httpOptions);
  }
  wakeUpCreatePdf() {
    return this.http.post(`${this.HttpUrl}/createpdf`, this.httpOptions);
  }
  wakeUpSendEmail() {
    return this.http.post(`${this.HttpUrl}/sendEmail`, this.httpOptions);
  }

  wakeBigQuery() {
    return this.http.post(`${this.HttpUrl}/bigquerymodule`, this.httpOptions);
  }

  getControlsBasicData() {
    const controls: ControlBase<string>[] = [
      new TextBox({
        key: 'numeroDocumento',
        label: 'Número de documento',
        value:
          this.personalInformation.identificacion ||
          this.stepsInformation.firstStep.numeroDocumento,
        required: true,
        maxLength: 11,
        pattern: '^[0-9]*$',
        layout: 'col w-100 col-sm-12',
        order: 2,
      }),
      new TextBox({
        key: 'celular',
        label: 'Celular',
        value:
          this.personalInformation.celularFormulario ||
          this.stepsInformation.firstStep.celular,
        minLength: 10,
        maxLength: 10,
        required: true,
        pattern: '^[0-9]*$',
        layout: 'col w-100 col-sm-12',
        order: 3,
        minCellNumber: true,
      }),
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  //Formulario de información personal
  // getControlsPersonalInformation() {
  //   const controls: ControlBase<string>[] = [
  //     new TextBox({
  //       key: 'primerNombre',
  //       label: 'Primer nombre',
  //       value:
  //         this.personalInformation.name ||
  //         this.stepsInformation.secondStep.primerNombre,
  //       required: true,
  //       pattern: '^[a-zA-Zs]*$',
  //       layout: 'col w-100',
  //       order: 1,
  //       isSpecialCharacters: true,
  //       maxLength: 100
  //     }),
  //     new TextBox({
  //       key: 'primerApellido',
  //       label: 'Primer apellido',
  //       value:
  //         this.personalInformation.primerApellido ||
  //         this.stepsInformation.secondStep.primerApellido,
  //       required: true,
  //       layout: 'col w-100 align-self-end',
  //       pattern: '^[a-zA-Zs]*$',
  //       maxLength: 14,
  //       order: 2,
  //       isSpecialCharacters: true
  //     }),

  //     new NumberInput({
  //       key: 'dia',
  //       label: 'Día',
  //       type: 'number',
  //       value: this.personalInformation.fechaExpedicion
  //         ? this.personalInformation.fechaExpedicion.split('/')[0]
  //         : this.stepsInformation.secondStep.dia,
  //       required: true,
  //       minLength: 1,
  //       maxLength: 2,
  //       min: 1,
  //       max: 31,
  //       isDay: true,
  //       layout: 'col w-100',
  //       pattern: '^[0-9]*$',
  //       title: `Fecha de <b>expedición</b> de tu <b>cédula</b`,
  //       order: 3,
  //     }),
  //     new NumberInput({
  //       key: 'mes',
  //       label: 'Mes',
  //       type: 'number',
  //       value: this.personalInformation.fechaExpedicion
  //         ? this.personalInformation.fechaExpedicion.split('/')[1]
  //         : this.stepsInformation.secondStep.mes,
  //       required: true,
  //       minLength: 1,
  //       maxLength: 2,
  //       min: 1,
  //       max: 12,
  //       isMonth: true,
  //       layout: 'col w-100 align-self-end',
  //       pattern: '^[0-9]*$',
  //       title: '',
  //       order: 4,
  //     }),
  //     new TextBox({
  //       key: 'anio',
  //       label: 'Año',
  //       value: this.personalInformation.fechaExpedicion
  //         ? this.personalInformation.fechaExpedicion.split('/')[2]
  //         : this.stepsInformation.secondStep.anio,
  //       required: true,
  //       maxLength: 4,
  //       layout: 'col w-100 align-self-end',
  //       title: '',
  //       pattern: '^[0-9]*$',
  //       order: 5,
  //     }),
  //   ];
  //   return of(controls.sort((a, b) => a.order - b.order));
  // }

  getSelectionFeesControls() {
    const controls: ControlBase<string>[] = [
      new DropdownClient({
        key: 'client',
        label: 'Selecciona una opción',
        optionsObject: this.clients,
        required: true,
        title: 'Elige un cliente',
        layout: 'col w-100',
        order: 1,
      }),
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  getSelectionBuyControls(arrayFees: number[]) {
    const controls: ControlBase<string>[] = [
      new Dropdown({
        key: 'numeroCuotas',
        label: 'Selecciona una opción',
        options: arrayFees.map((fees) => {
          return {
            key: fees.toString(),
            value: fees.toString(),
          };
        }),
        required: true,
        value: this.stepsInformation.thirdStep.numeroCuotas,
        title: '¿A cuantas cuotas quieres pagar la compra?',
        layout: 'col-md-12 col w-100',
        order: 2,
      }),
      new Currency({
        key: 'monto',
        label: 'Ingresa el valor de la compra',
        value: this.stepsInformation.thirdStep.monto,
        required: true,
        title: 'Ingresa el valor de compra',
        pattern: '^[0-9]*$',
        layout: 'col-xs-12 col-md-12 col w-100',
        order: 3,
        isCurrency: true,
      }),
      new TextBox({
        key: 'referenciaPago',
        label: 'Numero referencia de pago',
        value: this.stepsInformation.thirdStep.referenciaPago,
        required: true,
        title: 'Referencia de pago',
        layout: 'col-xs-12 col-md-12 col w-100',
        order: 4,
        maxLength: 32,
        pattern: /^[a-zA-Z0-9]+$/,
      }),
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  getSelectionPurchaseFees(arrayFees: number[]) {
    const controls: ControlBase<string>[] = [
      new Dropdown({
        key: 'numeroCuotas',
        label: 'Selecciona una opción',
        options: arrayFees.map((fees) => {
          return {
            key: fees.toString(),
            value: fees.toString(),
          };
        }),
        required: true,
        value: this.stepsInformation.thirdStep.numeroCuotas,
        title: '¿A cuantas cuotas quieres pagar la compra?',
        layout: 'col w-100',
        order: 2,
      }),
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  getSelectionFeesControlsWithRef(arrayFees: number[]) {
    const controls: ControlBase<string>[] = [
      new DropdownFees({
        key: 'numeroCuotas',
        label: 'Selecciona una opción',
        options: arrayFees.map((fees) => {
          return {
            key: fees.toString(),
            value: fees.toString(),
          };
        }),
        required: true,
        value: this.personalInformation.term.toString(),
        title: '¿A cuántas cuotas quieres pagar la compra?',
        layout: 'col w-100',
        order: 1,
      }),
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  getOtpControls() {
    const controls: ControlBase<string>[] = [
      new Code({
        key: 'otp',
        label: 'otp',
        value: '',
        required: true,
        layout: 'col w-100',
        maxLength: 4,
        minLength: 4,
        title: 'Ingresa el código',
        pattern: '^[0-9]*$',
        order: 6,
      }),
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  alertWait() {
    Swal.fire({
      title: 'Espera un momento, estamos validando tu información',
      allowOutsideClick: false,
      imageUrl: `assets/img/LogoApprobe.gif`,
      imageWidth: 'auto',
      imageHeight: 'auto',
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  openSnack(dataSnack: any) {
    this._snackBar.openFromComponent(SnackComponent, {
      data: dataSnack,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 8000,
    });
  }
  getCausalDenied(data: any): Observable<ActivityContractor[]> {
    return this.http
      .post<GeneralParameter>(
        `${this.HttpUrl}/generalinformation`,
        data,
        this.httpOptions
      )
      .pipe(map((value) => value.causalDeclined));
  }

  creditDenied(data: any): Observable<any> {
    return this.http.post<any>(`${this.HttpUrl}/IdVal`, data, this.httpOptions);
  }

  getAddressSuggestions(data: object): Observable<any> {
    return this.http.post(
      `${this.HttpUrl}/bigquerymodule`,
      data,
      this.httpOptions
    );
  }
}

/**
 import { ResponseCreateUserDruo } from '../models/druo.model';


const initDruo: ResponseCreateUserDruo = {
  id: "",
  uuid: "",
  code: "",
  type: "",
  first_name: "",
  last_name: "",
  organization: "",
  local_id: "",
  local_id_type: "",
  local_id_country: "",
  email: "",
  cellphone: "",
  creation_source: "",
  date_created_gmt: "",
  date_updated_gmt: "",
  exists: ""
}

  private _druo = new BehaviorSubject<ResponseCreateUserDruo>(initDruo);

  public get druo(): ResponseCreateUserDruo {
    return this._druo.getValue();
  }

  public set druo(v: ResponseCreateUserDruo) {
    this._druo.next(v);
  }

wakeUpDruo() {
    return this.http.post(`${this.HttpUrl}/druo`, this.httpOptions)
  }
 */
